import { render, staticRenderFns } from "./AboutMainContent.vue?vue&type=template&id=5af50f0f&scoped=true&"
import script from "./AboutMainContent.vue?vue&type=script&lang=js&"
export * from "./AboutMainContent.vue?vue&type=script&lang=js&"
import style0 from "./AboutMainContent.vue?vue&type=style&index=0&id=5af50f0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af50f0f",
  null
  
)

export default component.exports